<div class="flex flex-wrap mt-4 min-w">
    <h1 class="w-full">Generación de noticias de béisbol</h1>

    <h3 class="w-full">
        <p>Con esta herramienta usted podrá generar noticias sobre los partidos de béisbol efectuados en Cuba.</p>
        <p>Se utiliza como fuente al <a class="link-blue" href="http://www.beisbolcubano.cu/">Sitio
                Oficial de la Serie Nacional de Béisbol</a> donde se lleva un registro de las estadísticas de los
            partidos, información sobre los equipos, deportistas, reglamentos y otras informaciones relacionadas con
            este deporte.</p>
    </h3>

    <div *ngIf="calendarGames.length > 0" class="w-full">
        <h2>Calendario</h2>
        <div class="flex" style="margin-bottom: 10px;">
            <div class="text-valign mr-15">Filtrar</div>
            <input type="text" name="filter"
                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                placeholder="texto ..." [(ngModel)]="query" />
        </div>
        <div class="calendar-container">
            <div class="flex game-container" *ngFor="let item of calendarGames | searchGame:query">
                <div class="mr-15 text-valign w-40">({{item.gameId}})</div>
                <div *ngIf="item.subserie !== ''" class="mr-15 text-valign w-75">Subserie {{item.subserie}}</div>
                <div class="text-valign">
                    <img alt="localImg" style="border-style: none !important;" [src]="item.localImg" width="40"
                        height="40">
                </div>
                <div class="mr-5 text-valign w-125">{{item.local}}</div>
                <div class="mr-5 text-valign">-</div>
                <div class="text-valign">
                    <img alt="visitorImg" style="border-style: none !important;" [src]="item.visitorImg" width="40"
                        height="40">
                </div>
                <div class="mr-15 text-valign w-125">{{item.visitor}}</div>
                <div class="mr-15 text-valign w-52">({{item.result}})</div>
                <div *ngIf="item.date !== ''" class="mr-15 text-valign">
                    <i class="fa fa-calendar fa-1" aria-hidden="true"></i>
                    {{item.date}}
                </div>
                <div class="mr-15 text-valign w-180">{{item.stadium}}</div>
                <button
                    class="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm uppercase rounded shadow hover:shadow-lg p-3"
                    type="submit" (click)="select_url(item.gameId)">
                    SEL
                </button>
            </div>
        </div>
    </div>

    <form *ngIf="providerInfoForm !== undefined" name="provider-info" class="flex-auto px-20"
        [formGroup]="providerInfoForm">

        <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="url">
                URL con información del partido
            </label>
            <input type="text" name="url"
                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                placeholder="URL ..." formControlName="purl" required />
            <div *ngIf="providerInfoForm !== undefined && providerInfoForm.controls['purl'].invalid && (providerInfoForm.controls['purl'].dirty || providerInfoForm.controls['purl'].touched)"
                class="alert alert-danger">

                <div *ngIf="providerInfoForm.controls['purl'].errors?.required">
                    La URL debe ser especificada.
                </div>
            </div>
        </div>

        <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="token_compai">
                Token de CompAI
            </label>
            <input type="password" name="token-compai"
                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                placeholder="Token ..." formControlName="ptoken_compai" required />
            <div *ngIf="providerInfoForm !== undefined && providerInfoForm.controls['ptoken_compai'].invalid && (providerInfoForm.controls['ptoken_compai'].dirty || providerInfoForm.controls['ptoken_compai'].touched)"
                class="alert alert-danger">

                <div *ngIf="providerInfoForm.controls['ptoken_compai'].errors?.required">
                    El token de CompAI debe ser especificado.
                </div>
            </div>
            <div *ngIf="tokenHasError[0]" class="alert alert-danger">
                <div>{{tokenHasError[1]}}</div>
            </div>
        </div>

        <div class="text-center mt-6">
            <button
                class="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                type="submit" (click)="generate_news()" [disabled]="providerInfoForm.controls['purl'].invalid 
                || providerInfoForm.controls['ptoken_compai'].invalid">
                <span *ngIf='!isProcessingText'>Generar noticia</span>
                <span *ngIf='isProcessingText'>Generando ...</span>
            </button>
            <div *ngIf='isProcessingText && progressInfo.position !== null && !myIsNaN(progressInfo.position)'>
                [Hay {{progressInfo.position + 1}} tarea{{progressInfo.position === 0?'':'s'}} en cola antes de que
                comience la suya.]
            </div>
            <div *ngIf="hasErrorProcessing[0]" class="alert alert-danger">
                <div>{{hasErrorProcessing[1]}}</div>
            </div>
        </div>
    </form>

    <div class="w-full mb-12 px-4 mt-8" [hidden]='!showResults'>

        <div class="w-full flex flex-wrap">
            <div class="w-full px-4 my-2 flex-1">
                <section>
                    <h2>Alternativas</h2>
                    <div *ngFor="let item of newsGenerated; index as i">
                        <app-carousel [texts]="[item['original']].concat(item['paraphrases'])" [header]="headers[i]"
                            (currentIdxEvent)="updatedUnifiedText()" [item]="item" [collectionIdx]="i"
                            (showInUnifiedChanged)="updatedUnifiedText()">
                        </app-carousel>
                    </div>
                </section>
            </div>

            <div class="w-full px-4 my-2 flex-1">
                <section>
                    <h2>Unificada</h2>
                    <div class="unified-container">
                        <p *ngFor="let item of unifiedText">{{item}}</p>
                    </div>
                </section>
            </div>
        </div>
    </div>
</div>
